import { optionalStringParam, parseableSearchSchema } from "@crm/effect/schema/search";
import { Schema } from "effect";

const monthParam = Schema.String.pipe(Schema.check(Schema.isPattern(/^\d{4}-\d{2}$/)));

export const goalsSearchSchema = parseableSearchSchema(
  Schema.Struct({
    coach: optionalStringParam(),
    month: Schema.optional(monthParam),
  }),
);

export type GoalsSearch = Schema.Schema.Type<typeof goalsSearchSchema>;

export const revenueSearchSchema = parseableSearchSchema(
  Schema.Struct({
    month: Schema.optional(monthParam),
  }),
);

export type RevenueSearch = Schema.Schema.Type<typeof revenueSearchSchema>;

export const salarySearchSchema = parseableSearchSchema(
  Schema.Struct({
    month: Schema.optional(monthParam),
  })
);

export type SalarySearch = Schema.Schema.Type<typeof salarySearchSchema>;
